const BASE_URL = "https://looptager.com/api/service1"; // Base URL

export const fetchFromAccounts = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/account-holders`);
    if (!response.ok) {
      throw new Error("Error fetching from accounts.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching from accounts:", error);
    throw error;
  }
};

export const fetchToAccounts = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/beneficiaries/all`);
    if (!response.ok) {
      throw new Error("Error fetching to accounts.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching to accounts:", error);
    throw error;
  }
};

export const fetchBank2Accounts = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/account-holders2/all`);
    if (!response.ok) {
      throw new Error("Error fetching Bank 2 account details.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching Bank 2 account details:", error);
    throw error;
  }
};


